
import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { useValidation } from '../../../../../../../../../hooks/use-validation';
import { getCountries } from '../../../../../../../../../helpr/genericFormData';
import { getCurrency } from '../../../../../../../../../helpr/listingFormData';
import { securityInfoObj, securityInfoValidator, securityInfoValidatorPublished } from '../../../../../../../../../form-control/listing-form/security-info-control';
import { getCouponTypes } from '../../../../../../../../../helpr/listingFormData';

import { FormGroup, TextInput, NumericInput, CurrencyInput, DropDown, InputGroup, DateInput } from '../../../../../../../../../components/form/form';

import CouponInfo from '../coupon-info/coupon-info';
import CouponFrequency from '../coupon-frequency/coupon-frequency';
import OptionalRedemptionDates from '../optional-redemption-dates/optional-redemption-dates';

import styles from './security-information.module.scss'
import SecurityInfo from '../../../../../../../../../models/securityInfo';
import Listing from '../../../../../../../../../models/listing';
import { PATTERN_ALPHA_NUMERIC_SPACE, PATTERN_TENOR } from '../../../../../../../../../helpr/constants';


const SecurityInformation = ({listingInfo, saveListingInfo, nextStep}) => {
  const newSecurityInfo = new SecurityInfo(listingInfo.securityList[0]);
  const securityInfo = {
    ...newSecurityInfo,
    offerPeriodFrom: listingInfo.offerPeriodFrom,
    offerPeriodTo: listingInfo.offerPeriodTo
  }

  const today = new Date();
  today.setDate(today.getDate() + 1);
  const dateToday = listingInfo.isPublished? null: [
    today.getFullYear(),
    ('0'+ parseInt(today.getMonth() +1).toString()).slice(-2),('0'+today.getDate()).slice(-2)
  ].join('-');


  const validatorObj = listingInfo.isPublished? securityInfoValidatorPublished: securityInfoValidator;
  const securityFormState = useValidation(validatorObj, securityInfoObj(securityInfo), {border: '1px solid red'});
  const { getTextFieldProps, getDropdownProps, getField, validate } = securityFormState;

  const saveSecurityInfo = (formState) => {
    console.log(formState);
    const newListingInfo = new Listing({
      ...listingInfo,
      securityList: [ new SecurityInfo({...formState,
        denomination: {
          primary: {
            minimum: formState.primaryMarketMinDenomination,
            increments: formState.primaryMarketMinIncrements
          },
          secondary: {
            minimum: formState.secondaryMarketMinDenomination,
            increments: formState.secondaryMarketMinIncrements
          }
        }
      }) ],
      offerPeriodFrom: getField('offerPeriodFrom'),
      offerPeriodTo: getField('offerPeriodTo'),
    })
    saveListingInfo(newListingInfo);
  }

  const nextHandler = (step) => {
    const { isFormValid, formState } = validate();
    if( step ){ nextStep(step); }
    else if( isFormValid ){
      saveSecurityInfo(new SecurityInfo(formState));
      nextStep(step)
    }
    else { /*Invalid Form State*/ }
  }

  return (
    <div className={styles['security-information-component']}>
      <Row>
        <Col>
          <InputGroup header="SECURITY NAME">
            <Row className="mt-2">
              <Col sm={6} lg={6}>
                <TextInput inputProps={getTextFieldProps('longName')} maxLength="150">
                  Long Name:*
                </TextInput>
                <TextInput inputProps={getTextFieldProps('prefShortName')} maxLength="75">
                  Preferred Short Name:*
                </TextInput>
              </Col>
            </Row>
          </InputGroup>
          <InputGroup header="ISSUE DETAILS" style={{paddingTop: '0px'}}>
            <Row className="mt-2">
              <Col sm={6} lg={3}>
                <DropDown inputProps={getDropdownProps('countryOfIssue')} values={getCountries()}>
                  Country of Issue:*
                </DropDown>
              </Col>
              <Col sm={6} lg={3}>
                <DropDown inputProps={getDropdownProps('currency')} values={getCurrency()}>
                  Issue Currency:*
                </DropDown>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col sm={6} lg={3}>
                <DateInput inputProps={getTextFieldProps('listingDate')} min={dateToday}>
                  Issue/Listing Date:*
                </DateInput>
              </Col>
              <Col sm={6} lg={3}>
                <DateInput inputProps={getTextFieldProps('maturityDate')} min={getField('listingDate')}>
                  Maturity Date:*
                </DateInput>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col sm={6} lg={3}>
                <CurrencyInput inputProps={getTextFieldProps('amount')} placeholder="0.00" noDecimal>
                  Issue / Reopening Amount:*
                </CurrencyInput>
              </Col>
              <Col sm={6} lg={3}>
                <CurrencyInput inputProps={getTextFieldProps('amountOutstanding')} placeholder="0.00" noDecimal>
                  Total Amount Outstanding (for Reopening):
                </CurrencyInput>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col sm={6} lg={3}>
                <TextInput inputProps={getTextFieldProps('tenor')} maxLength="50" pattern={PATTERN_TENOR}>
                  Tenor:*
                </TextInput>
              </Col>
              <Col sm={6} lg={3}>
                <NumericInput inputProps={getTextFieldProps('issuePrice')} decimalLimit={4} numberLimit={1000} variant="default">
                  Issue Price (%):*
                </NumericInput>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col sm={6} lg={3}>
                <NumericInput inputProps={getTextFieldProps('redemptionPrice')} decimalLimit={4} numberLimit={1000} variant="default">
                  Redemption Price (%):*
                </NumericInput>
              </Col>
            </Row>
            <OptionalRedemptionDates securityFormState={securityFormState} isPublished={listingInfo.isPublished}/>
          </InputGroup>
          <InputGroup header="PRIMARY MARKET" style={{paddingTop: '0px'}}>
            <Row className="mt-1">
              <Col sm={6} lg={4}>
                <CurrencyInput inputProps={getTextFieldProps('primaryMarketMinDenomination')} placeholder="0" maxLength="50" noDecimal>
                  Minimum Denomination:*
                </CurrencyInput>
              </Col>
              <Col sm={6} lg={4}>
                <CurrencyInput inputProps={getTextFieldProps('primaryMarketMinIncrements')} placeholder="0" maxLength="50" noDecimal>
                  Minimum Increments:*
                </CurrencyInput>
              </Col>
            </Row>
          </InputGroup>
          <InputGroup header="SECONDARY MARKET" style={{paddingTop: '0px'}}>
            <Row className="mt-1">
              <Col sm={6} lg={4}>
                <CurrencyInput inputProps={getTextFieldProps('secondaryMarketMinDenomination')} placeholder="0" maxLength>
                  Minimum Denomination:*
                </CurrencyInput>
              </Col>
              <Col sm={6} lg={4}>
                <CurrencyInput inputProps={getTextFieldProps('secondaryMarketMinIncrements')} placeholder="0">
                  Minimum Increments:*
                </CurrencyInput>
              </Col>
            </Row>
          </InputGroup>
          <InputGroup header="COUPON TYPE:*" style={{paddingTop: '0px'}}>
            <Row className="mt-1">
              <Col sm={6} lg={4}>
                <DropDown inputProps={getDropdownProps('couponType')} values={getCouponTypes()}/>
              </Col>
            </Row>
            <CouponInfo securityFormState={securityFormState}/>
          </InputGroup>
          <InputGroup header="COUPON FREQUENCY:*" style={{paddingTop: '0px', marginBottom: '30px'}}>
            <CouponFrequency securityFormState={securityFormState}/>
          </InputGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup header="OFFER PERIOD">
            <Row className="mt-1">
              <Col sm={6} lg={3}>
                <DateInput inputProps={getTextFieldProps('offerPeriodFrom')} min={dateToday}>
                  From:*
                </DateInput>
              </Col>
              <Col sm={6} lg={3}>
                <DateInput inputProps={getTextFieldProps('offerPeriodTo')} min={getField('offerPeriodFrom')}>
                  To:*
                </DateInput>
              </Col>
            </Row>
          </FormGroup>
        </Col>
      </Row>
      <Row className={styles['btn-actions']}>
        <Button onClick={()=>nextHandler(true)} className="btn-secondary">BACK</Button>
        <Button onClick={()=>nextHandler()}>NEXT</Button>
      </Row>
    </div>
  )
}

export default SecurityInformation;
